var map = {
	"./de/general1/slide3.svg": 659324,
	"./en/general1/slide3.svg": 856408,
	"./es/general1/slide3.svg": 274741,
	"./fr/general1/slide3.svg": 219469,
	"./nl/general1/slide3.svg": 494907,
	"./pt/general1/slide3.svg": 776153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 730090;